import { API } from '../Api';
import { ArenaChallenge, ArenaChallengeType, unwrap } from './arena.api';

// Admin Arena. Gọi từ trang /admin nên axios tự dùng token CMS; không gửi auid.
const BASE = '/v1/group-service/admin/arena';

interface Wrapped<T> {
  httpCode: number;
  message: string;
  data: T;
}

export interface ArenaChallengeUpsert {
  title: string;
  description?: string;
  rules?: string;
  startAt: string;
  submitDeadline: string;
  judgingDeadline: string;
  teamSizeMin: number;
  teamSizeMax: number;
  interactionWeight: number;
  pointsRank1?: number;
  pointsRank2?: number;
  pointsRank3?: number;
  pointsRank4To10?: number;
  pointsParticipation?: number;
  type: ArenaChallengeType;
  categoryId: string | null;
}

export interface ArenaAdminMember {
  userId: string;
  clanIdSnapshot?: string | null;
  isLeader: boolean;
}

export interface ArenaAdminEntry {
  teamId: string;
  teamName: string;
  members: ArenaAdminMember[];
  postId?: string | null;
  postAuthorId?: string | null;
  submittedAt?: string | null;
  likes: number;
  comments: number;
  shares: number;
  interactionRaw: number;
  qualityScore?: number | null;
  disqualified: boolean;
  disqualifyReason?: string | null;
  note?: string | null;
  warning?: string | null;
}

export const adminListChallenges = () =>
  API.get<Wrapped<ArenaChallenge[]>>(`${BASE}/list`).then(unwrap);

export const adminCreateChallenge = (body: ArenaChallengeUpsert) =>
  API.post<Wrapped<ArenaChallenge>>(`${BASE}/create`, body).then(unwrap);

export const adminUpdateChallenge = (id: string, body: ArenaChallengeUpsert) =>
  API.put<Wrapped<ArenaChallenge>>(`${BASE}/update`, body, { params: { id } }).then(unwrap);

export const adminPublishChallenge = (id: string) =>
  API.post<Wrapped<ArenaChallenge>>(`${BASE}/publish`, null, { params: { id } }).then(unwrap);

export const adminCancelChallenge = (id: string) =>
  API.post<Wrapped<ArenaChallenge>>(`${BASE}/cancel`, null, { params: { id } }).then(unwrap);

export const adminListEntries = (challengeId: string) =>
  API.get<Wrapped<ArenaAdminEntry[]>>(`${BASE}/entries`, { params: { challengeId } }).then(unwrap);

export const adminScoreEntry = (teamId: string, quality: number) =>
  API.post<Wrapped<boolean>>(`${BASE}/score`, { teamId, quality }).then(unwrap);

export const adminDisqualifyEntry = (teamId: string, reason: string) =>
  API.post<Wrapped<boolean>>(`${BASE}/disqualify`, { teamId, reason }).then(unwrap);

export const adminFinalizeChallenge = (id: string) =>
  API.post<Wrapped<ArenaChallenge>>(`${BASE}/finalize`, null, { params: { id } }).then(unwrap);
